'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _Sizes = require('./Sizes');

var _Sizes2 = _interopRequireDefault(_Sizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Grid = function (_Component) {
  _inherits(Grid, _Component);

  function Grid() {
    _classCallCheck(this, Grid);

    return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));
  }

  _createClass(Grid, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          column = _props.column,
          relaxed = _props.relaxed,
          centered = _props.centered,
          stackable = _props.stackable,
          reversed = _props.reversed,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['column', 'relaxed', 'centered', 'stackable', 'reversed', 'className']);

      var cx = (0, _classnames2.default)(column ? _Sizes2.default[column - 1] + ' column' : null, {
        relaxed: relaxed,
        centered: centered,
        stackable: stackable,
        reversed: reversed
      }, 'grid', className);

      return _react2.default.createElement(_Box2.default, _extends({
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Grid;
}(_react.Component);

Grid.displayName = 'Grid';

Grid.propTypes = {
  column: _propTypes2.default.number,
  relaxed: _propTypes2.default.bool,
  centered: _propTypes2.default.bool,
  stackable: _propTypes2.default.bool,
  reversed: _propTypes2.default.bool
};

exports.default = Grid;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkdyaWQuanMiXSwibmFtZXMiOlsiR3JpZCIsInByb3BzIiwiY29sdW1uIiwicmVsYXhlZCIsImNlbnRlcmVkIiwic3RhY2thYmxlIiwicmV2ZXJzZWQiLCJjbGFzc05hbWUiLCJyZXN0IiwiY3giLCJkaXNwbGF5TmFtZSIsInByb3BUeXBlcyIsIm51bWJlciIsImJvb2wiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7OztJQUVNQSxJOzs7Ozs7Ozs7Ozs2QkFDSztBQUFBLG1CQVNILEtBQUtDLEtBVEY7QUFBQSxVQUVMQyxNQUZLLFVBRUxBLE1BRks7QUFBQSxVQUdMQyxPQUhLLFVBR0xBLE9BSEs7QUFBQSxVQUlMQyxRQUpLLFVBSUxBLFFBSks7QUFBQSxVQUtMQyxTQUxLLFVBS0xBLFNBTEs7QUFBQSxVQU1MQyxRQU5LLFVBTUxBLFFBTks7QUFBQSxVQU9MQyxTQVBLLFVBT0xBLFNBUEs7QUFBQSxVQVFGQyxJQVJFOztBQVVQLFVBQUlDLEtBQUssMEJBQ1BQLFNBQVksZ0JBQU1BLFNBQVMsQ0FBZixDQUFaLGVBQXlDLElBRGxDLEVBRVA7QUFDRUMsd0JBREY7QUFFRUMsMEJBRkY7QUFHRUMsNEJBSEY7QUFJRUM7QUFKRixPQUZPLEVBUVAsTUFSTyxFQVNQQyxTQVRPLENBQVQ7O0FBWUEsYUFDRTtBQUNFLGdCQURGO0FBRUUsbUJBQVdFO0FBRmIsU0FHTUQsSUFITixFQURGO0FBT0Q7Ozs7OztBQUdIUixLQUFLVSxXQUFMLEdBQW1CLE1BQW5COztBQUVBVixLQUFLVyxTQUFMLEdBQWlCO0FBQ2ZULFVBQVEsb0JBQVVVLE1BREg7QUFFZlQsV0FBUyxvQkFBVVUsSUFGSjtBQUdmVCxZQUFVLG9CQUFVUyxJQUhMO0FBSWZSLGFBQVcsb0JBQVVRLElBSk47QUFLZlAsWUFBVSxvQkFBVU87QUFMTCxDQUFqQjs7a0JBUWViLEkiLCJmaWxlIjoiR3JpZC5qcyIsInNvdXJjZVJvb3QiOiJEOlxcUHJvamVjdHNcXHJlYWN0LXRvY2FzXFxzcmMifQ==



//////////////////
// WEBPACK FOOTER
// ../lib/Grid.js
// module id = 566
// module chunks = 0